// extracted by mini-css-extract-plugin
export default {"root":"Graphic_root__G4x1b"};